import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './_common/shared.module';
import { JwtInterceptor } from './_helpers/http-interceptor';
import { TranslateConfigService } from './_services/translate-config.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


@NgModule({
	declarations: [AppComponent],
	bootstrap: [AppComponent],
	imports: [
		BrowserModule.withServerTransition({ appId: 'serverApp' }),
		IonicModule.forRoot(),
		AppRoutingModule,
		SharedModule,
		MatTooltipModule,
		BrowserAnimationsModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: (HttpLoaderFactory),
				deps: [HttpClient]
			}
		})], providers: [
			{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
			{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
			// Errors/hints reserve a single fixed-height line by default, so a
			// multi-line validation message (e.g. the password policy text)
			// overflows and overlaps the field below it instead of pushing it
			// down. 'dynamic' lets the subscript area grow with its content.
			{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } },
			TranslateConfigService,
			TranslateService,
			provideHttpClient(withInterceptorsFromDi()),
		]
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, "./assets/language/", ".json");
}
